module.exports = __webpack_public_path__ + "img/sport-6-@3x.3ea88997.png";